<div class="dialog">
  <mat-icon class="dialog__close" aria-hidden="false" aria-label="Close icon" (click)="onClose()">close</mat-icon>
  <div mat-dialog-title>
    <header>{{translatedData.selectAttachment}}</header>
  </div>
  <form>
    <div mat-dialog-content class="content">
      <div class="mediaInfo" *ngIf="images.length ;else noImagesBlock">
        <div *ngFor="let media of images">
          <div class="media-block">
            <div class="image-block">
              <div class="container">
                <div
                  miq-bg-image
                  [imageSrc]="media.sanitized_media_path"
                  [publishable]="media.publishable"
                  color="image-container default"
                ></div>
              </div>
            </div>
            <div class="file-name-block">
              <div class="media-select">
                <mat-checkbox
                  *ngIf="multiSelect"
                  [id]="media?.id"
                  [name]="media?.media_name"
                  [(ngModel)]="media.checked"
                  (change)="selectImage()"
                >
                  {{ media?.media_name }}
                </mat-checkbox>
                <mat-radio-button
                  [checked]="media.id === selectedMedia?.id"
                  *ngIf="!multiSelect"
                  class="radio-button"
                  (click)="selectImage(media)"
                >
                  <span class="wrap-radion-button-label"> {{ media?.media_name }} </span>
                </mat-radio-button>
                <div class="caption">{{ media?.media_caption }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ng-template #noImagesBlock>
        <div class="no-records">
          <!-- TODO: Need to add icon -->
          {{translatedData.noImagesFound}}
        </div>
      </ng-template>

      <div mat-dialog-actions class="mat-dialog-actions">
        <span *ngIf="navigationMessage" class="navigationMessage" (click)="navigate()">
          {{translatedData.navigationMessage}}
          <mat-icon svgIcon="icon-upload" color="y-upload" class="mat-icon-upload"></mat-icon>
          <span class="add-new"> {{ translatedData.addNew }}</span>
        </span>
        <span class="select-btn">
          <button mat-flat-button color="primary" (click)="select()">{{translatedData.select}}</button>
        </span>
      </div>
    </div>
  </form>
</div>
